/* Gym Layout Designer Knowledge Base */
(function() {
  'use strict';

  var kb = document.querySelector('.gld-kb');
  if (!kb) return;

  /* ── Element references ── */
  var searchInput = kb.querySelector('.gld-kb__search-input');
  var searchClear = kb.querySelector('.gld-kb__search-clear');
  var tabBar = kb.querySelector('.gld-kb__tabs');
  var tabs = kb.querySelectorAll('.gld-kb__tab');
  var categories = kb.querySelectorAll('.gld-kb__category');
  var accordions = kb.querySelectorAll('.gld-kb__accordion');
  var noResults = kb.querySelector('.gld-kb__no-results');

  /* ── Dark Mode Sync ── */
  function syncDarkMode() {
    var isDark = localStorage.getItem('rd_darkMode') === '1';
    kb.classList.toggle('gld-kb--dark', isDark);
  }

  syncDarkMode();

  /* Listen for changes from the Room Designer toggle */
  var roomDesigner = document.querySelector('.room-designer');
  if (roomDesigner) {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class') {
          syncDarkMode();
          break;
        }
      }
    });
    observer.observe(roomDesigner, { attributes: true, attributeFilter: ['class'] });
  }

  /* Also listen for storage events (cross-tab sync) */
  window.addEventListener('storage', function(e) {
    if (e.key === 'rd_darkMode') syncDarkMode();
  });

  /* ── Deselect all tabs & hide all categories ── */
  function deselectAll() {
    tabs.forEach(function(tab) {
      tab.classList.remove('gld-kb__tab--active');
      tab.setAttribute('aria-selected', 'false');
    });
    categories.forEach(function(panel) {
      panel.hidden = true;
    });
    noResults.hidden = true;
  }

  /* ── Tabs ── */
  function activateTab(selectedTab) {
    var category = selectedTab.getAttribute('data-category');

    tabs.forEach(function(tab) {
      var isSelected = tab === selectedTab;
      tab.classList.toggle('gld-kb__tab--active', isSelected);
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    categories.forEach(function(panel) {
      if (category === 'all') {
        panel.hidden = false;
      } else {
        panel.hidden = panel.getAttribute('data-category') !== category;
      }
    });

    /* Clear search when switching tabs */
    if (searchInput.value.trim()) {
      searchInput.value = '';
      searchClear.hidden = true;
      accordions.forEach(function(accordion) {
        accordion.classList.remove('gld-kb__accordion--hidden');
      });
    }

    noResults.hidden = true;
  }

  tabBar.addEventListener('click', function(e) {
    var tab = e.target.closest('.gld-kb__tab');
    if (!tab) return;
    triggerHaptic();

    /* Toggle: clicking the active tab deselects it */
    if (tab.classList.contains('gld-kb__tab--active')) {
      deselectAll();
    } else {
      activateTab(tab);
    }
  });

  /* Keyboard navigation for tabs */
  tabBar.addEventListener('keydown', function(e) {
    var tabArray = Array.prototype.slice.call(tabs);
    var currentIndex = tabArray.indexOf(document.activeElement);
    if (currentIndex === -1) return;

    var newIndex;
    if (e.key === 'ArrowRight') {
      newIndex = (currentIndex + 1) % tabArray.length;
    } else if (e.key === 'ArrowLeft') {
      newIndex = (currentIndex - 1 + tabArray.length) % tabArray.length;
    } else if (e.key === 'Home') {
      newIndex = 0;
    } else if (e.key === 'End') {
      newIndex = tabArray.length - 1;
    } else {
      return;
    }

    e.preventDefault();
    tabArray[newIndex].focus();
    activateTab(tabArray[newIndex]);
  });

  /* ── Haptic feedback ── */
  function triggerHaptic() {
    if ('vibrate' in navigator) {
      navigator.vibrate(50);
    }
  }

  /* ── Accordions ── */
  function toggleAccordion(header) {
    var isOpen = header.getAttribute('aria-expanded') === 'true';
    var bodyId = header.getAttribute('aria-controls');
    var body = document.getElementById(bodyId);
    if (!body) return;

    var icon = header.querySelector('.gld-kb__accordion-icon');

    triggerHaptic();

    if (isOpen) {
      /* Close */
      body.style.maxHeight = body.scrollHeight + 'px';
      body.offsetHeight; /* force reflow */
      body.style.maxHeight = '0';
      header.setAttribute('aria-expanded', 'false');
      if (icon) icon.textContent = '+';
    } else {
      /* Open */
      body.style.maxHeight = body.scrollHeight + 'px';
      header.setAttribute('aria-expanded', 'true');
      if (icon) icon.textContent = '\u2212';

      /* Remove inline max-height after transition so content can reflow */
      var onEnd = function() {
        body.removeEventListener('transitionend', onEnd);
        if (header.getAttribute('aria-expanded') === 'true') {
          body.style.maxHeight = 'none';
        }
      };
      body.addEventListener('transitionend', onEnd);
    }
  }

  kb.addEventListener('click', function(e) {
    var header = e.target.closest('.gld-kb__accordion-header');
    if (!header) return;
    toggleAccordion(header);
  });

  /* ── Search ── */
  var searchTimeout;

  function performSearch(query) {
    query = query.toLowerCase().trim();

    if (!query) {
      clearSearch();
      return;
    }

    /* Show all categories during search (override tab selection) */
    categories.forEach(function(panel) {
      panel.hidden = false;
    });

    var totalMatches = 0;

    accordions.forEach(function(accordion) {
      var title = accordion.querySelector('.gld-kb__accordion-title');
      var body = accordion.querySelector('.gld-kb__accordion-content');
      var text = (title ? title.textContent : '') + ' ' + (body ? body.textContent : '') + ' ' + (accordion.getAttribute('data-tags') || '');
      var matches = text.toLowerCase().indexOf(query) !== -1;

      accordion.classList.toggle('gld-kb__accordion--hidden', !matches);
      if (matches) totalMatches++;
    });

    /* Hide empty categories */
    categories.forEach(function(panel) {
      var visibleItems = panel.querySelectorAll('.gld-kb__accordion:not(.gld-kb__accordion--hidden)');
      panel.hidden = visibleItems.length === 0;
    });

    noResults.hidden = totalMatches > 0;
  }

  function clearSearch() {
    accordions.forEach(function(accordion) {
      accordion.classList.remove('gld-kb__accordion--hidden');
    });

    /* Return to no-selection state */
    deselectAll();
  }

  searchInput.addEventListener('input', function() {
    var value = searchInput.value;
    searchClear.hidden = !value.trim();

    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(function() {
      performSearch(value);
    }, 250);
  });

  searchClear.addEventListener('click', function() {
    searchInput.value = '';
    searchClear.hidden = true;
    clearSearch();
    searchInput.focus();
  });

  /* ── Deep Linking ── */
  function handleDeepLink() {
    var hash = window.location.hash;
    if (!hash) return;

    var target = kb.querySelector(hash);
    if (!target || !target.classList.contains('gld-kb__accordion')) return;

    /* Make sure the category is visible */
    var panel = target.closest('.gld-kb__category');
    if (panel) {
      var category = panel.getAttribute('data-category');
      var matchingTab = kb.querySelector('.gld-kb__tab[data-category="' + category + '"]');
      if (matchingTab) activateTab(matchingTab);
    }

    /* Open the accordion */
    var header = target.querySelector('.gld-kb__accordion-header');
    if (header && header.getAttribute('aria-expanded') !== 'true') {
      toggleAccordion(header);
    }

    /* Scroll into view */
    setTimeout(function() {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }

  handleDeepLink();
  window.addEventListener('hashchange', handleDeepLink);

  /* ── JSON-LD FAQPage Schema ── */
  function generateJsonLd() {
    var questions = [];

    accordions.forEach(function(accordion) {
      var titleEl = accordion.querySelector('.gld-kb__accordion-title');
      var contentEl = accordion.querySelector('.gld-kb__accordion-content');
      if (!titleEl || !contentEl) return;

      var name = titleEl.textContent.trim();
      var text = contentEl.textContent.trim();
      if (!name || !text) return;

      questions.push({
        '@type': 'Question',
        'name': name,
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': text
        }
      });
    });

    if (questions.length === 0) return;

    var schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      'mainEntity': questions
    };

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    kb.appendChild(script);
  }

  generateJsonLd();

  /* ── Back to Top ── */
  function initBackToTop() {
    var backToTop = kb.querySelector('.gld-kb__back-to-top');
    if (!backToTop) return;

    backToTop.hidden = false;

    var searchBar = kb.querySelector('.gld-kb__search');
    var ticking = false;

    function updateBackToTop() {
      var searchBottom = searchBar.getBoundingClientRect().bottom;
      var anyOpen = kb.querySelector('.gld-kb__category:not([hidden])');
      var kbBottom = kb.getBoundingClientRect().bottom;
      var buttonTop = window.innerHeight - 76; /* 32px bottom + 44px height */
      var inKbRange = kbBottom > buttonTop;
      backToTop.classList.toggle('gld-kb__back-to-top--visible', searchBottom < 0 && !!anyOpen && inKbRange);
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateBackToTop);
        ticking = true;
      }
    }, { passive: true });

    backToTop.addEventListener('click', function() {
      kb.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* Run immediately or after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackToTop);
  } else {
    initBackToTop();
  }

})();
